<template>
  <el-dialog
    title="编辑班内职务"
    :visible.sync="postDialog.flag"
    :close-on-click-modal="false"
    @close="handleClose"
    destroy-on-close
    width="500px"
  >
    <el-form ref="lForm" :model="lObject" size="small" :rules="rules">
      <el-row>
        <el-col>
          <el-form-item prop="classPost">
            <el-select 
              class=" select-content"
              v-model="lObject.classPost" 
              placeholder="请选择班内职务">
              <el-option
                v-for="(item, i) in postTypeList"
                :key="i"
                :label="item.paramValue"
                :value="item.paramKey"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <butn @click="handleClose" title="取消"></butn>
      <butn btntype="primary" @click="submitForm" title="确定"></butn>
    </div>
  </el-dialog>
</template>

<script>
import butn from "@/components/button/index";
import { updatePost } from "@/api/enrollOffline";
import { getDataMap } from "@/api/sysParam";
export default {
  components: { butn },
  props: {
    postDialog: {
      type: Object,
      default: () => {
        return {
          flag: false
        };
      },
    },
    lObject: {
      type: Object,
      default: () => {
        return {
          classPost: "",
          uuid: ""
        };
      }
    }
  },
  data() {
    return {
      title: "",
      rules: {
        classPost: [
          {
            required: true,
            message: "请输入班内职务",
            trigger: ["change", "blur"],
          },
        ],
      },
      postTypeList: [],
    };
  },
  methods: {
    handleClose() {
      this.$refs["lForm"].resetFields();
      this.$emit('closeDialog', false);
    },
    submitForm() {
      this.$refs["lForm"].validate((valid) => {
        if (valid) {
          let params = {
            uuid: this.lObject.uuid,
            classPost: this.lObject.classPost,
          };
          updatePost(params).then((res) => {
            if (!res || res.code != 0) return;
            this.$emit('closeDialog', true);
          });
        }
      });
    },
  },
  created() {
    getDataMap("CLASS_POST_TYPE").then((res) => {
      if (!res || res.code != 0) return;
      if (res.data && res.data.length > 0) {
        // let list = res.data.filter((item) => item.paramValue.indexOf('组长') === -1)
        // 王祥飞说放开职位过滤组长的筛选
        this.postTypeList = res.data;
      }  
    });
  }
};
</script>

<style lang="scss" scoped>
.select-content {
  width: 100% !important;
}
</style>
